import { useState } from 'react';
import { Visit } from '../types';

export const useVisits = () => {
  const [visits, setVisits] = useState<Visit[]>([]);

  const addVisit = (visit: Visit) => {
    setVisits(prev => [...prev, visit]);
  };

  const updateVisit = (updatedVisit: Visit) => {
    setVisits(prev => prev.map(visit => 
      visit.id === updatedVisit.id ? updatedVisit : visit
    ));
  };

  const deleteVisit = (id: string) => {
    setVisits(prev => prev.filter(visit => visit.id !== id));
  };

  return {
    visits,
    addVisit,
    updateVisit,
    deleteVisit
  };
};